// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__38H24","question":"Question_question__oJXcs","description":"Question_description__2KdWY"};